import { FormValues } from '../../components/case/CaseForm';
import { PaymentType } from '../../stateMachines/submitCase/selectPaymentType';
import { CaseType } from '../../stateMachines/submitCase/caseType';

export interface EditCaseDraft {
  caseId: string;
  caseInfo?: FormValues;
  paymentType: PaymentType;
  selectedPaymentMethod?: string;
  selectedInvoiceAccountUid?: string;
  caseType: CaseType;
}

function getStorageKey(caseId: string): string {
  return `editCaseDraft_${caseId}`;
}

export function saveEditCaseDraft(caseId: string, draft: EditCaseDraft): void {
  try {
    const key = getStorageKey(caseId);
    const serialized = JSON.stringify(draft);
    sessionStorage.setItem(key, serialized);
  } catch (error) {
    console.error('Failed to save edit case draft:', error);
  }
}

export function loadEditCaseDraft(caseId: string): EditCaseDraft | null {
  try {
    const key = getStorageKey(caseId);
    const serialized = sessionStorage.getItem(key);

    if (!serialized) {
      return null;
    }

    const draft = JSON.parse(serialized) as EditCaseDraft;

    if (draft.caseId !== caseId) {
      console.warn('Draft caseId mismatch, clearing draft');
      sessionStorage.removeItem(key);
      return null;
    }

    return draft;
  } catch (error) {
    console.error('Failed to load edit case draft:', error);
    return null;
  }
}

export function clearEditCaseDraft(caseId: string): void {
  try {
    const key = getStorageKey(caseId);
    sessionStorage.removeItem(key);
  } catch (error) {
    console.error('Failed to clear edit case draft:', error);
  }
}
